// Shared chrome for the platform-admin pages. Top bar with nav, sign-out,
// the watermark "PLATFORM" so operators never confuse this with a tenant view.

import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { usePlatformAuth } from '../lib/platformAuth.jsx';

export default function PlatformLayout() {
  const { user, logout } = usePlatformAuth();
  const nav = useNavigate();
  if (!user) {
    nav('/platform/login', { replace: true });
    return null;
  }
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="bg-slate-900 text-slate-100 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/platform" className="font-bold text-amber-400">M2B • PLATFORM</Link>
            <nav className="flex gap-3 text-sm">
              <PlatformNav to="/platform" end label="Tenants" />
              <PlatformNav to="/platform/audit" label="Audit" />
              <PlatformNav to="/platform/health" label="Health" />
            </nav>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <span className="text-slate-400">{user.full_name}</span>
            <span className="px-2 py-0.5 rounded text-xs bg-amber-500 text-slate-900 font-medium">{user.role}</span>
            <button onClick={() => { logout(); nav('/platform/login'); }}
              className="text-slate-400 hover:text-slate-100">Sign out</button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
function PlatformNav({ to, end, label }) {
  return (
    <NavLink to={to} end={end}
      className={({ isActive }) => `px-2 py-1 rounded ${isActive ? 'bg-slate-800 text-amber-400' : 'text-slate-300 hover:bg-slate-800/60'}`}>
      {label}
    </NavLink>
  );
}
